import api from "./axios";

const BASE = "/transactions";

export const listUploadedTransactions = (params = {}) =>
  api.get(`${BASE}/uploaded`, { params });

export const listManualTransactions = (params = {}) =>
  api.get(`${BASE}/manual`, { params });

export const listYetToPay = (params = {}) =>
  api.get(`${BASE}/yet-to-pay`, { params });

export const listApprovedTransactions = (params = {}) =>
  api.get(`${BASE}/approved`, { params });

export const listAppEntries = (params = {}) =>
  api.get(`${BASE}/app-entries`, { params });

export const getReconciliation = (params = {}) =>
  api.get(`${BASE}/reconciliation`, { params });

export const createManualEntry = (payload) =>
  api.post(`${BASE}/manual`, payload);

export const uploadTransactionsFile = (formData) =>
  api.post(`${BASE}/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const downloadTransactionTemplate = () =>
  api.get(`${BASE}/template`, { responseType: "blob" });

export const approveTransaction = (id) =>
  api.put(`${BASE}/${id}/approve`);

export const rejectTransaction = (id, payload) =>
  api.put(`${BASE}/${id}/reject`, payload);

export const updateTransaction = (id, payload) =>
  api.put(`${BASE}/${id}`, payload);

export const deleteTransaction = (id) =>
  api.delete(`${BASE}/${id}`);

export const exportTransactions = (params = {}) =>
  api.get(`${BASE}/export`, { params, responseType: "blob" });
